export enum SSE_HEADER_QUERY_PARAMS {
	accessToken = 'accessToken',
	tz = 'tz',
	projectId = 'project-id',
	organizationId = 'organization-id',
	username = 'username',
	workDayHours = 'workDayHours',
	isDemo = 'is-demo',
}
